import { type ReactElement } from 'react'
import { useQueryState } from 'nuqs'
import { parseAsUserId } from '@util'
import { createFileRoute } from '@tanstack/react-router'
import { UserList, useUserViewTab, ViewUserPanel } from '@components'

function UserListPage(): ReactElement {
  const [viewUser, setViewUser] = useQueryState('viewUser', parseAsUserId)
  const [, setTab] = useUserViewTab()

  const close = (): void => {
    setViewUser(null)
    setTab(null)
  }

  return (
    <UserList
      onRowClick={({ userId }) => setViewUser(userId)}
      panel={<ViewUserPanel userId={viewUser ?? undefined} onClose={close} />}
    />
  )
}

export const Route = createFileRoute('/user/')({
  component: UserListPage,
})
